import facebookIcon from '../images/facebook-icon.svg';
import emailIcon from '../images/email-icon.svg';
import twitterIcon from '../images/twitter-icon.svg';
import linkedinIcon from '../images/linkedIn-icon.svg';
import facebookIconBlue from '../images/facebook-icon-blue.svg';
import emailIconBlue from '../images/email-icon-blue.svg';
import twitterIconBlue from '../images/twitter-icon-blue.svg';
import linkedinIconBlue from '../images/linkedIn-icon-blue.svg';

export const socialData = [
  {
    class: 'addthis_button_twitter',
    icon: twitterIcon,
    iconBlue: twitterIconBlue,
    alt: 'Share to Twitter',
    platform: 'Twitter',
  },
  {
    class: 'addthis_button_facebook',
    icon: facebookIcon,
    iconBlue: facebookIconBlue,
    alt: 'Share to Facebook',
    platform: 'Facebook',
  },
  {
    class: 'addthis_button_linkedin',
    icon: linkedinIcon,
    iconBlue: linkedinIconBlue,
    alt: 'Share to LinkedIn',
    platform: 'LinkedIn',
  },
  {
    class: 'addthis_button_email',
    icon: emailIcon,
    iconBlue: emailIconBlue,
    alt: 'Share to Email',
    platform: 'Email',
  },
];
